
import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Bateau } from '@/hooks/useBateaux';
import { Anchor } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface SelecteurNavireProps {
  bateaux: Bateau[];
  selectedBateauId: string | null;
  onBateauChange: (bateauId: string) => void;
}

const SelecteurNavire = ({ bateaux, selectedBateauId, onBateauChange }: SelecteurNavireProps) => {
  const { t } = useTranslation('boats');
  const handleValueChange = (value: string) => {
    console.log('Navire sélectionné:', value);
    onBateauChange(value);
  };

  return (
    <div className="flex items-center gap-3">
      <Anchor className="h-5 w-5 text-nautic" />
      <Select value={selectedBateauId || ""} onValueChange={handleValueChange}>
        <SelectTrigger className="w-full max-w-[400px]">
          <SelectValue placeholder={t("selecteurNavire.placeholder")} />
        </SelectTrigger>
        <SelectContent className="bg-white z-50">
          {bateaux.map((bateau) => (
            <SelectItem key={bateau.id} value={bateau.id}>
              <div className="flex flex-col">
                <span className="font-medium">{bateau.nom}</span>
                <span className="text-sm text-gray-500">
                  {bateau.nom_constructeur} {bateau.nom_modele} ({bateau.annee})
                </span>
              </div>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default SelecteurNavire;
